import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/auth/auth.service';

export const riskManagerGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isRiskManager()) {
    return true;
  }

  // optional redirect
  return router.createUrlTree(['/']);
};
